import React from 'react';
import { Field } from 'formik';

import Select from 'components/common/form/Select';
import { TASK_STATUSES } from 'constants/tasks';

const TaskStatusFilter = () => (
    <Field
        name='status'
        component={Select}
        placeholder='Выберите статус'
        options={TASK_STATUSES}
        allowClear={true} />
);

export default TaskStatusFilter;
